import { itemMarkerIcon } from "./item-marker-icon";

const ITEM_SIZE_DEFAULTS = {
    scaledSize: new google.maps.Size(30, 40),
    anchor: new google.maps.Point(15, 40)
};

export const ITEM_DEFAULT = (index, overrides = {}): google.maps.MarkerOptions => ({
    icon: {
        url: itemMarkerIcon(index),
        ...ITEM_SIZE_DEFAULTS,
        ...overrides
    },
    zIndex: 2,
    // animation: google.maps.Animation.DROP 
});
